import { render, staticRenderFns } from "./detail-receipts.vue?vue&type=template&id=6230e40c&scoped=true"
import script from "./detail-receipts.vue?vue&type=script&lang=js"
export * from "./detail-receipts.vue?vue&type=script&lang=js"
import style0 from "./detail-receipts.vue?vue&type=style&index=0&id=6230e40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230e40c",
  null
  
)

export default component.exports